export default __webpack_public_path__ + "static/Bunker_Customs_banner_mobile-92b39cc941bc7935fdaeb996cc3e0e6b.jpg";